import * as yup from "yup";

const EXISTING_SOURCE_INITIAL_VALUES = {
  existingSource: "",
};

const EXISTING_SOURCE_VALIDATION_SCHEMA = yup.object({
  existingSource: yup.object().required("Source is required"),
});

const EXISTING_DESTINATION_INITIAL_VALUES = {
  existingDestination: "",
};

const EXISTING_DESTINATION_VALIDATION_SCHEMA = yup.object({
  existingDestination: yup.object().required("Target is required"),
});

const FIELD_TYPES = {
  integer: "number",
  string: "text",
  password: "password",
};

const SOURCE_INTITIAL_VALUES = {
  source: "",
  type: "",
};

const SOURCE_VALIDATION_SCHEMA = yup.object({
  source: yup.string().trim().required("Source name is required"),
  type: yup.object().required("Type is required"),
});

const DESTINATION_INTIIAL_VALUES = {
  destination: "",
  type: "",
};

const DESTINATION_VALIDATION_SCHEMA = yup.object({
  destination: yup.string().trim().required("Target name is required"),
  type: yup.object().required("Type is required"),
});

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGE_NUMBER = 1;

const FREQUENCY_UNITS = [
  "5 minutes",
  "15 minutes",
  "30 minutes",
  "1 hours",
  "2 hours",
  "3 hours",
  "6 hours",
  "8 hours",
  "12 hours",
  "24 hours",
];

const FREQUENCY_OPTIONS_WITHOUT_MANUAL = FREQUENCY_UNITS.map(unit => {
  const [time, timeUnit] = unit.split(" ");
  return {
    label: `Every ${time === "1" ? "hour" : unit}`,
    value: { units: Number(time), timeUnit },
  };
});

const MANUAL_FREQUENCY_OPTION = { label: "Manual", value: null };

const FREQUENCY_OPTIONS = [
  MANUAL_FREQUENCY_OPTION,
  ...FREQUENCY_OPTIONS_WITHOUT_MANUAL,
];

const IMAGE_URLS = {
  source: "/bigquery.svg",
  target: "/postgres.svg",
  login: "/login.svg",
};

const CONFIG_TYPES = { sync: "Sync", reset_connection: "Reset" };

const INITIAL_REPLICATION_VALUES = {
  frequency: MANUAL_FREQUENCY_OPTION,
  namespaceDefinition: { label: "Mirror source structure", value: "source" },
  namespaceFormat: "${SOURCE_NAMESPACE}",
};

const NAMESPACE_OPTIONS = [
  { label: "Mirror source structure", value: "source" },
  { label: "Custom format", value: "customformat" },
  { label: "Destination default", value: "destination" },
];

export {
  EXISTING_SOURCE_INITIAL_VALUES,
  EXISTING_SOURCE_VALIDATION_SCHEMA,
  FIELD_TYPES,
  DEFAULT_PAGE_SIZE,
  DEFAULT_PAGE_NUMBER,
  SOURCE_VALIDATION_SCHEMA,
  EXISTING_DESTINATION_VALIDATION_SCHEMA,
  EXISTING_DESTINATION_INITIAL_VALUES,
  DESTINATION_VALIDATION_SCHEMA,
  FREQUENCY_OPTIONS,
  MANUAL_FREQUENCY_OPTION,
  IMAGE_URLS,
  CONFIG_TYPES,
  SOURCE_INTITIAL_VALUES,
  DESTINATION_INTIIAL_VALUES,
  INITIAL_REPLICATION_VALUES,
  NAMESPACE_OPTIONS,
};
